import React from 'react';
import { motion } from 'framer-motion';
import RacePlannerCharacters from './RacePlannerCharacters/RacePlannerCharacters';
import RacePlannerTitle from './RacePlannerTitle';
import RacePlannerTimeline from './RacePlannerTimeline/RacePlannerTimeline';
import RacePlannerFilters from './RacePlannerFilters/RacePlannerFilters';
import { RaceEngineProvider } from './RaceEngine/RaceEngineContext';

/**
 * interface-design § Visual Excellence: Masterpiece Title & Navigation Context
 * animation-designer § Pattern 4 (High-end entry transition)
 */
const RacePlanner = () => {
    return (
        <RaceEngineProvider>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="relative min-h-screen bg-slate-50 dark:bg-[#0B0F19] px-6 py-6 md:px-12 md:py-8 text-slate-800 dark:text-white selection:bg-[#48E5B9] selection:text-black transition-colors duration-500 overflow-x-hidden"
            >
                {/* ── Fondos de Vanguardia ──────────────────────────────────
                frontend-design § Backgrounds: Layered mesh gradients y Noise texture
                para evitar el look plano de los gradientes estándar. */}
                <div className="absolute inset-0 -z-20 overflow-hidden">
                    {/* Mesh Gradient Animado (Simulado con blur y movimiento) */}
                    <motion.div
                        animate={{
                            scale: [1, 1.2, 1],
                            rotate: [0, 10, 0],
                        }}
                        transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
                        className="absolute top-[-20%] right-[-10%] w-[80vw] h-[80vw] bg-gradient-to-br from-[#FAB0C0]/10 dark:from-[#FAB0C0]/20 to-transparent rounded-full blur-[120px] md:blur-[160px] mix-blend-multiply dark:mix-blend-screen opacity-70 dark:opacity-60"
                    />
                    <motion.div
                        animate={{
                            scale: [1, 1.1, 1],
                            rotate: [0, -15, 0],
                        }}
                        transition={{ duration: 25, repeat: Infinity, ease: 'linear' }}
                        className="absolute bottom-[-10%] left-[-20%] w-[70vw] h-[70vw] bg-gradient-to-tr from-[#48E5B9]/10 dark:from-[#48E5B9]/15 to-transparent rounded-full blur-[100px] md:blur-[140px] mix-blend-multiply dark:mix-blend-screen opacity-70 dark:opacity-40"
                    />
                    {/* Textura de Ruido (Subtle Grain eliminado por 403) */}
                    <div className="absolute inset-0 opacity-[0.04] dark:opacity-[0.03] pointer-events-none bg-black/5 dark:bg-white/5" />
                </div>

                <div className="max-w-7xl mx-auto relative">
                    {/* ── MASTERPIECE TITLE ────────────────────────────────────
                    frontend-design § Typography: Dual-layer impact title.
                    No es solo texto; es una composición visual. */}
                    <RacePlannerTitle />

                    <main className="relative z-10 w-full overflow-hidden">
                        {/* ── Módulo Principal de Personajes ───────────────────────
                        Estructuralmente limpio, visualmente sofisticado. */}
                        <div className="grid grid-cols-1 gap-12 w-full max-w-full">
                            <motion.section
                                initial={{ opacity: 0, y: 40 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                            >
                                <RacePlannerCharacters />
                                <RacePlannerFilters />
                                <RacePlannerTimeline />
                            </motion.section>
                        </div>
                    </main>
                </div>
            </motion.div>
        </RaceEngineProvider>
    );
};

export default RacePlanner;
